import { Icon } from "@tokenterminal/core/ui/icon/Icon"

import { type ReactNode } from "react"

import { toast as sonnerToast, type ToastT } from "sonner"

const toast = ({
  body,
  icon,
}: {
  body: ReactNode
  icon?: React.ElementType
}): ToastT["id"] => {
  return sonnerToast(
    <div className="flex gap-2 items-center justify-between w-full">
      <div className="flex gap-3 items-center">
        {icon && <Icon as={icon} width={16} />}
        <div className="text-sm font-medium">{body}</div>
      </div>
    </div>
  )
}

export default toast
